import axios from 'axios';
import * as luxon from 'luxon';
import * as zxcvbn from 'ts-zxcvbn';
import * as uuid from 'uuid';

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _wrapRegExp() {
  _wrapRegExp = function (e, r) {
    return new BabelRegExp(e, void 0, r);
  };
  var e = RegExp.prototype,
    r = new WeakMap();
  function BabelRegExp(e, t, p) {
    var o = RegExp(e, t);
    return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype);
  }
  function buildGroups(e, t) {
    var p = r.get(t);
    return Object.keys(p).reduce(function (r, t) {
      var o = p[t];
      if ("number" == typeof o) r[t] = e[o];else {
        for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++;
        r[t] = e[o[i]];
      }
      return r;
    }, Object.create(null));
  }
  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) {
    var t = e.exec.call(this, r);
    if (t) {
      t.groups = buildGroups(t, this);
      var p = t.indices;
      p && (p.groups = buildGroups(p, this));
    }
    return t;
  }, BabelRegExp.prototype[Symbol.replace] = function (t, p) {
    if ("string" == typeof p) {
      var o = r.get(this);
      return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) {
        var t = o[r];
        return "$" + (Array.isArray(t) ? t.join("$") : t);
      }));
    }
    if ("function" == typeof p) {
      var i = this;
      return e[Symbol.replace].call(this, t, function () {
        var e = arguments;
        return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
      });
    }
    return e[Symbol.replace].call(this, t, p);
  }, _wrapRegExp.apply(this, arguments);
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

const NUMBER = {
  DEFAULT_CONVERSATION: 0,
  DEFAULT_DAY_COUNT: 0,
  DEFAULT_MAXIMUM_Y_AXIS: 5,
  FIVE: 5,
  HUNDRED: 100,
  INCREMENTATION_ONE: 1,
  MAXIMUM_RATIO: 1,
  MAX_LENGTH_PROMPT: 2000,
  MAX_LENGTH_QUERY_DOCUMENT_ELASTICSEARCH: 10000,
  MAX_SIZE_FILE_SHAREPOINT: 10485760,
  MINIMUM_RATIO: 0,
  NUMBER_OF_PARAPHRASES: 21,
  ONE_DIGIT: 1,
  TEN: 10,
  THREE: 3,
  THREE_DECIMALS: 3,
  TIME_CONVERSATION_IN_MINUTES: 15,
  TWO_DIGITS: 2,
  VALID_PASSWORD_SCORE: 3,
  WHATSAPP_MAX_BUTTONS: 3,
  WHATSAPP_MAX_CHAR_IN_BUTTON: 19,
  WHATSAPP_MAX_CHAR_IN_SECTION_BUTTON: 24,
  ZERO: 0
};
const ARRAY = {
  EMPTY_LENGTH: 0,
  FIRST_INDEX: 0,
  LAST_ITEM: -1,
  ONE_ITEM_LENGTH: 1,
  SECOND_INDEX: 1,
  TWO_ITEM_LENGTH: 2
};
const STRING = {
  EMPTY_LENGTH: 0,
  FIRST_CHARACTER_INDEX: 0,
  FIRST_NEGATIVE_CHARACTER_INDEX: -1,
  SECOND_CHARACTER_INDEX: 1,
  THIRD_CHARACTER_INDEX: 2
};
const PASSWORD = {
  MINIMUM_STRENGTH: 3,
  SALT_ROUNDS: 10
};
const TIME = {
  DAYS_IN_A_WEEK: 7,
  FIFTEEN_SECONDS: 15,
  HOUR_IN_A_DAY: 24,
  // eslint-disable-next-line unicorn/numeric-separators-style
  MILLISECONDS_IN_A_DAY: 86400000,
  // eslint-disable-next-line unicorn/numeric-separators-style
  MILLISECONDS_IN_A_MINUTE: 60000,
  MILLISECONDS_IN_A_SECOND: 1000,
  MILLISECONDS_IN_A_SECOND_AND_A_HALF: 1500,
  MILLISECONDS_IN_THREE_SECOND: 3000,
  MINUTES_IN_HOURS: 60,
  SECONDS_FOR_A_LOG: 3,
  SECONDS_IN_AN_HOUR: 3600,
  // eslint-disable-next-line unicorn/numeric-separators-style
  SECONDS_IN_A_DECADE: 315576000,
  SECONDS_IN_A_MINUTE: 60,
  // eslint-disable-next-line unicorn/numeric-separators-style
  SECONDS_IN_A_MONTH: 2592000,
  SECONDS_IN_FIFTEEN_MINUTES: 900,
  SECONDS_IN_HALF_AN_HOUR: 1800
};
const DATE = {
  DEFAULT_END_DATE: new Date('2970-01-01T00:00:00Z'),
  DEFAULT_START_DATE: new Date('1970-01-01T00:00:00Z')
};
const isDomainError = (maybeError, errorsList
// @ts-expect-error type
) => Object.values(errorsList).includes(maybeError);
const getEnvironment = processEnvironment => variableName => {
  const variable = processEnvironment[variableName];
  if (variable === undefined) {
    throw new TypeError(`"${variableName}" environment does not exist`);
  }
  return variable;
};
const getEnvironments = processEnvironment => variableNames => {
  const missingEnvironmentVariables = variableNames.filter(variableName => {
    return processEnvironment[variableName] === undefined;
  });
  if (missingEnvironmentVariables.length > ARRAY.EMPTY_LENGTH) {
    throw new TypeError(`Missing environment variables: "${missingEnvironmentVariables.join(',')}"`);
  }
  return variableNames.map(variableName => {
    return processEnvironment[variableName];
  });
};
const isObject = maybeObject => maybeObject instanceof Object;
const sanitizeError = maybeError => {
  if (typeof maybeError === 'string') {
    console.error(maybeError);
    return new Error(maybeError);
  }
  if (maybeError instanceof Error) {
    // console.error(maybeError.message)
    return maybeError;
  }
  if (maybeError instanceof Object) {
    console.error(JSON.stringify(maybeError));
    return new Error(JSON.stringify(maybeError));
  }
  console.error('Unexpected error');
  return new Error('Unexpected error');
};
const throwSanitizeError = (maybeError, errors) => {
  if (errors !== undefined) {
    throw sanitizeError(errors[maybeError]);
  }
  throw sanitizeError(maybeError);
};
const HTTP_CODE = {
  BAD_REQUEST: 400,
  CONFLICT: 409,
  FORBIDDEN: 403,
  INTERNAL_ERROR: 500,
  METHOD_NOT_ALLOWED: 405,
  MOVED_PERMANENTLY: 301,
  NOT_ACCEPTABLE: 406,
  NOT_FOUND: 404,
  NO_CONTENT: 204,
  OK: 200,
  PAYMENT_REQUIRED: 402,
  REDIRECT: 302,
  REQUEST_ENTITY_TOO_LARGE: 413,
  UNAUTHORIZED: 401,
  UNSUPPORTED_MEDIA_TYPE: 415
};
const isString = data => typeof data === 'string';
const isBoolean = data => typeof data === 'boolean';
const isNumber = data => typeof data === 'number';
const isArray = data => Array.isArray(data);
const isJson = json => {
  try {
    JSON.parse(json);
  } catch (_a) {
    return false;
  }
  return true;
};
const isEmpty = data => {
  if (typeof data === 'string') {
    return data.trim().length === STRING.EMPTY_LENGTH;
  }
  if (Array.isArray(data)) {
    return data.length === ARRAY.EMPTY_LENGTH;
  }
  if (typeof data === 'object') {
    return Object.keys(data).length === STRING.EMPTY_LENGTH;
  }
  return true;
};
const hasValues = object => Object.values(object).some(value => value !== null && value !== undefined);
const isEmailValid = email => /^(?:[\0-\x08\x0E-\x1F!-\?A-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+@(?:[\0-\x08\x0E-\x1F!-\?A-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+\.(?:[\0-\x08\x0E-\x1F!-\?A-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+$/.test(email);
const isProfessionalEmail = email => /^(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+?@(?:(?!gmail\.com|hotmail\.fr|hotmail\.com|yahoo\.com|yahoo\.fr|jupimail\.com|spam\.la|yopmail\.com|yopmail\.com|spamfree24\.org|dontreg\.com|10minutemail\.com|jetable\.org|mail\x2Dtemporaire\.fr|get2mail\.fr|email\x2Djetable\.fr)(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))+$/.test(email);
const removeEmailAndNumbers = string => {
  const stringWithoutEmailAndNumbers = string.replace(/(?:[\0-\x08\x0E-\x1F!-\?A-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+@(?:[\0-\x08\x0E-\x1F!-\?A-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+\.(?:[\0-\x08\x0E-\x1F!-\?A-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+|\+?[0-9]*/g, '').replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF][\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+/g, ' ').trim();
  return isEmpty(stringWithoutEmailAndNumbers) ? null : stringWithoutEmailAndNumbers;
};
const removeEmojis = string => {
  const stringWithoutEmojis = string.replace(
  // eslint-disable-next-line require-unicode-regexp
  /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '').replace(/[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF][\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+/g, ' ').trim();
  return isEmpty(stringWithoutEmojis) ? null : stringWithoutEmojis;
};
const isStringLongEnough = (string, minimalLength = 1) => isEmpty(string) ? false : string.split(' ').length > minimalLength;
const isWebsiteUrlValid = website =>
// eslint-disable-next-line unicorn/no-unsafe-regex
/^(?!\.)(?:ht{2}ps?:\/{2})?(?:[\x2D\.0-9A-Z_a-z]{2,}){0,100}(?:(?:(?:\.|\/)(?:[0-9A-Z_a-z]|[&\x2D\.=\?\{\}]){2,}){1,100})(?:\/?)$/.test(website);
const isUrlValid = url =>
// eslint-disable-next-line unicorn/no-unsafe-regex
/^http(s)?:\/\/([\x2D0-9a-z]+\.)+[a-z]{2,}(\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/.test(url);
const isValidTimestamp = timestamp => {
  if (typeof timestamp === 'number' && timestamp.toString().length < 12) {
    return false;
  }
  return new Date(timestamp).getTime() > 0;
};
const isValidColor = stringColor => {
  const testColor = /^#[0-9a-f]{6}$/i.test(stringColor);
  return testColor === true;
};
const cleanUrl = url => {
  const regexArray = /*#__PURE__*/_wrapRegExp(/((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)(\?|#)/, {
    cleanUrl: 1,
    params: 2
  }).exec(url);
  return regexArray === null || regexArray.groups === undefined ? url : regexArray.groups.cleanUrl;
};
const getUrlDomain = url => {
  const regexArray = /*#__PURE__*/_wrapRegExp(/http(s)?:\/\/(www\.)?(([0-9A-Z_a-z]|[0-9]|\.|\x2D)*)/, {
    secure: 1,
    web: 2,
    urlDomain: 3,
    urlDomainElement: 4
  }).exec(url);
  return regexArray === null || regexArray.groups === undefined ? null : regexArray.groups.urlDomain;
};
const convertWebsiteToName = website => website.replace(/^https*:\/\/(?:www\.)*(?=(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]))/, '');
const convertBotNameToAgentInboxName = botName => botName.replace(/["-,\.\/:<>\?\\\{\}~]/g, ' ').replace(/ +(?= )/g, '').trim();
const isStrongPassword = password => {
  const result = zxcvbn.default(password);
  return result.score >= PASSWORD.MINIMUM_STRENGTH;
};
const generateUniqueId = () => uuid.v4();
const longStringLength = 128;
const generateRandomString = (requiredLength = longStringLength, allowedCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789') => {
  const selectOneRandomCharacter = () => {
    return allowedCharacters.charAt(Math.floor(Math.random() * allowedCharacters.length));
  };
  const buildString = (requiredLength, generatedString) => {
    if (generatedString.length < requiredLength) {
      const newGeneratedString = generatedString + selectOneRandomCharacter();
      return buildString(requiredLength, newGeneratedString);
    }
    return generatedString;
  };
  return buildString(requiredLength, '');
};
const generateRandomNumber = (max = 1000000) => Math.floor(Math.random() * max);
const generateRandomTagId = () => {
  return `${generateRandomString(20)}${generateRandomNumber()}`;
};
const capitalizeString = string => string.replace(/^[0-9A-Z_a-z]/, firstLetter => firstLetter.toUpperCase());
const generatedRandomPassword = (requiredLength = longStringLength, alphaMin = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ', alphaMaj = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', numbers = '0123456789', symbols = '!@#$%^&*_-+=') => {
  const randomChar = chars => {
    return chars.charAt(Math.floor(Math.random() * chars.length));
  };
  const buildPassword = (requiredLength, generatedString) => {
    if (generatedString.length < requiredLength) {
      const newGeneratedString = generatedString + randomChar(alphaMaj) + randomChar(alphaMin) + randomChar(numbers) + randomChar(symbols);
      return buildPassword(requiredLength, newGeneratedString);
    }
    return generatedString;
  };
  return buildPassword(requiredLength, '');
};
const getRandomElementInStringList = list => list[Math.floor(Math.random() * list.length)];
const getRandomElementInArray = array => {
  if (array.length === ARRAY.EMPTY_LENGTH) {
    return undefined;
  }
  const randomIndex = Math.floor(Math.random() * array.length);
  return array[randomIndex];
};
const defaultBasePathApi = 'https://api.sendinblue.com/v3';
const defaultHeadersApi = {
  Accept: 'application/json',
  'content-type': 'application/json'
};
const sendTransacEmail = apiKey => bodySendSmtpEmail => __awaiter(void 0, void 0, void 0, function* () {
  const url = `${defaultBasePathApi}/smtp/email`;
  try {
    yield axios.post(url, bodySendSmtpEmail, {
      headers: Object.assign(Object.assign({}, defaultHeadersApi), {
        'api-key': apiKey
      })
    });
  } catch (error) {
    throw sanitizeError(error);
  }
});
const formatDate = (date, type = 'number-with-year') => {
  switch (type) {
    case 'number':
      {
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);
        return `${month}-${day}`;
      }
    case 'number-with-year':
      {
        const year = `${date.getFullYear()}`;
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);
        return `${year}-${month}-${day}`;
      }
    case 'text':
      {
        const localeDate = date.toLocaleString('en-GB', {
          day: 'numeric',
          month: 'short'
        });
        return `${localeDate.split(' ').join(' ')}.`;
      }
    case 'text-with-year':
      {
        const year = `${date.getFullYear()}`;
        const localeDate = date.toLocaleString('en-GB', {
          day: 'numeric',
          month: 'short'
        });
        return `${localeDate.split(' ').join(' ')}. ${year}`;
      }
    case 'dd/mm/yyyy':
      {
        const year = `${date.getFullYear()}`;
        const month = `0${date.getMonth() + 1}`.slice(-2);
        const day = `0${date.getDate()}`.slice(-2);
        return `${day}/${month}/${year}`;
      }
    default:
      return '';
  }
};
const getLocalDayOfWeekFromDate = date => {
  const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  return days[date.getDay()];
};
const getUtcDayOfWeekFromDate = date => {
  const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  return days[date.getUTCDay()];
};
const getHoursDiff = (startDate, endDate) => {
  const msInHour = 1000 * 60 * 60;
  return Math.floor(Math.abs(endDate.getTime() - startDate.getTime()) / msInHour);
};
const getDateEveryHourInPeriod = (startDate, endDate) => {
  const hoursDiff = getHoursDiff(startDate, endDate);
  const indexesArray = Array.from({
    length: hoursDiff
  }).map((item, index) => index + 1);
  const dateMap = new Map();
  dateMap.set(0, new Date(startDate));
  const everyHourinPeriodReduce = indexesArray.reduce((accumulator, currentValue) => {
    const temporaryDateToAdd = new Date(startDate);
    temporaryDateToAdd.setHours(temporaryDateToAdd.getHours() + currentValue);
    accumulator.set(currentValue, temporaryDateToAdd);
    return accumulator;
  }, dateMap);
  const everyHourInPeriod = [...everyHourinPeriodReduce.values()];
  return everyHourInPeriod;
};
const getUniqueDaysAndHoursInPeriod = (startDate, endDate) => {
  const dateEveryHourInPeriod = getDateEveryHourInPeriod(startDate, endDate);
  const daysAndHoursInPeriod = dateEveryHourInPeriod.map(date => {
    const day = getUtcDayOfWeekFromDate(date);
    const hourFromDate = date.getUTCHours();
    const hour = hourFromDate < NUMBER.TEN ? `0${hourFromDate}` : hourFromDate.toString();
    return {
      day,
      hour
    };
  });
  return daysAndHoursInPeriod.filter((value, index, self) => index === self.findIndex(dayAndHour => dayAndHour.day === value.day && dayAndHour.hour === value.hour));
};
const getLastWeekDate = () => {
  const actualDate = new Date();
  actualDate.setUTCHours(0, 0, 0, 0);
  return new Date(actualDate.setUTCDate(actualDate.getUTCDate() - TIME.DAYS_IN_A_WEEK));
};
const getOnePeriod = periodName => {
  switch (periodName) {
    case 'yesterday':
      {
        const date = new Date();
        date.setDate(date.getDate() - NUMBER.ONE_DIGIT);
        return {
          endDate: new Date(date.setUTCHours(23, 59, 59, 999)),
          startDate: new Date(date.setUTCHours(0, 0, 0, 0))
        };
      }
    default:
      {
        const date = new Date();
        return {
          endDate: new Date(date.setUTCHours(23, 59, 59, 999)),
          startDate: new Date(date.setUTCHours(0, 0, 0, 0))
        };
      }
  }
};
const subtractMinutesFromDate = (date, min) => {
  date.setMinutes(date.getMinutes() - min);
  return date;
};
const getStartOfDayDate = date => {
  const newDate = date;
  newDate.setUTCHours(0, 0, 0, 0);
  return newDate;
};
const getEndOfDayDate = date => {
  const newDate = date;
  newDate.setUTCHours(23, 59, 59, 999);
  return newDate;
};
const convertUtcHourToLocal = (utcHour, timeZone) => {
  const date = new Date();
  date.setUTCHours(utcHour, 0, 0, 0);
  return date.toLocaleString('fr-FR', {
    hour: '2-digit',
    hour12: false,
    timeZone
  });
};
const convertDateToString = date => {
  const year = `${date.getUTCFullYear()}`;
  const month = `0${date.getUTCMonth() + 1}`.slice(-2);
  const day = `0${date.getUTCDate()}`.slice(-2);
  return `${year}-${month}-${day}`;
};
const convertDateToStringFormat = (date, format) => {
  const year = `${date.getUTCFullYear()}`;
  const month = `0${date.getUTCMonth() + 1}`.slice(-2);
  const day = `0${date.getUTCDate()}`.slice(-2);
  const hour = `0${date.getHours()}`.slice(-2);
  const minute = `0${date.getMinutes()}`.slice(-2);
  const second = `0${date.getSeconds()}`.slice(-2);
  if (format === 'shortDateTimeFR') {
    return `${day}/${month}/${year} ${hour}:${minute}`;
  }
  if (format === 'shortDateTimeEN') {
    return `${year}/${month}/${day} ${hour}:${minute}`;
  }
  if (format === 'onlyDateFR') {
    return `${day}/${month}/${year}`;
  }
  if (format === 'onlyDateEN') {
    return `${year}/${month}/${day}`;
  }
  if (format === 'fullFR') {
    return `${day}/${month}/${year} ${hour}:${minute}:${second}`;
  }
  return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
};
const convertDateTimeZoneToUtcString = (date, timeZone) => {
  return luxon.DateTime.fromISO(date.replace('Z', ''), {
    zone: timeZone
  }).toUTC().toString();
};
const wait = (millisecondsDelay = 1000) => __awaiter(void 0, void 0, void 0, function* () {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, millisecondsDelay);
  });
});
const isValidPhoneNumber = phoneNumber => {
  // eslint-disable-next-line unicorn/no-unsafe-regex
  const regexPhone = /(((\+|00)33[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?|0)[1-9](([\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]?|\.)[0-9]{2}){4})/;
  return regexPhone.test(phoneNumber);
};
const getNbDaysBetweenTwoDates = (dateStart, dateEnd) => {
  dateStart.setUTCHours(0, 0, 0, 0);
  dateEnd.setUTCHours(0, 0, 0, 0);
  const differenceTimeTwoDates = dateEnd.getTime() + TIME.MILLISECONDS_IN_A_DAY - dateStart.getTime();
  return differenceTimeTwoDates / TIME.MILLISECONDS_IN_A_DAY;
};
const splitArray = (array, chunkSize) => {
  return Array.from({
    length: Math.ceil(array.length / chunkSize)
  },
  // eslint-disable-next-line id-length, @typescript-eslint/naming-convention
  (_, index) => array.slice(index * chunkSize, (index + 1) * chunkSize));
};
const getListNumberPages = (countValue, limit) => {
  const nbPages = Math.ceil(countValue / limit);
  return Array.from({
    length: nbPages
  },
  // eslint-disable-next-line @typescript-eslint/naming-convention, id-length
  (_, index) => index + 1);
};
const uniqueStringArray = list => list.filter((value, index, array) => array.indexOf(value) === index);
const accessTokenApplication = (axiosInstance, authManagementExpressBaseUrl, appId, appSecret) => () => __awaiter(void 0, void 0, void 0, function* () {
  try {
    const result = yield axiosInstance.post(`${authManagementExpressBaseUrl}/v1/token`, {
      app_id: appId,
      app_secret: appSecret,
      grant_type: 'client_credentials',
      scope: 'openid profile email'
    });
    return result.data;
  } catch (_a) {
    return null;
  }
});
const authenticatedApplicationRequest = (axios, authManagementExpressBaseUrl, appId, appSecret) => (method, url, body = {}, headers = {}) => __awaiter(void 0, void 0, void 0, function* () {
  const accessToken = yield accessTokenApplication(axios, authManagementExpressBaseUrl, appId, appSecret)();
  const requestHeaders = accessToken === null ? Object.assign({}, headers) : Object.assign(Object.assign({}, headers), {
    Authorization: `Bearer ${accessToken.access_token}`
  });
  try {
    switch (method) {
      case 'get':
      case 'delete':
        return (yield axios[method](url, {
          headers: Object.assign({}, requestHeaders)
        })).data;
      case 'post':
      case 'put':
      case 'patch':
        return (yield axios[method](url, body, {
          headers: Object.assign({}, requestHeaders)
        })).data;
      default:
        throw new Error('HTTP method not allowed');
    }
  } catch (error) {
    throw sanitizeError(error);
  }
});

export { ARRAY, DATE, HTTP_CODE, NUMBER, PASSWORD, STRING, TIME, authenticatedApplicationRequest, capitalizeString, cleanUrl, convertBotNameToAgentInboxName, convertDateTimeZoneToUtcString, convertDateToString, convertDateToStringFormat, convertUtcHourToLocal, convertWebsiteToName, formatDate, generateRandomNumber, generateRandomString, generateRandomTagId, generateUniqueId, generatedRandomPassword, getDateEveryHourInPeriod, getEndOfDayDate, getEnvironment, getEnvironments, getHoursDiff, getLastWeekDate, getListNumberPages, getLocalDayOfWeekFromDate, getNbDaysBetweenTwoDates, getOnePeriod, getRandomElementInArray, getRandomElementInStringList, getStartOfDayDate, getUniqueDaysAndHoursInPeriod, getUrlDomain, hasValues, isArray, isBoolean, isDomainError, isEmailValid, isEmpty, isJson, isNumber, isObject, isProfessionalEmail, isString, isStringLongEnough, isStrongPassword, isUrlValid, isValidColor, isValidPhoneNumber, isValidTimestamp, isWebsiteUrlValid, removeEmailAndNumbers, removeEmojis, sanitizeError, sendTransacEmail, splitArray, subtractMinutesFromDate, throwSanitizeError, uniqueStringArray, wait };
